import React, { useMemo } from 'react';
import { useDashboardFeatureFlags } from '@components';
import { AddSectionModalView } from './AddSectionModalView';
import { useAvailableSections } from './hooks/useAvailableSections';
import { useInstalledPlatformApps } from './hooks/useInstalledPlatformApps';
import { useSection } from './hooks/useSection';
import { useSectionConfigurations } from './hooks/useSectionConfigurations';
export const AddSectionModalContainer = ({ blockId, type, position }) => {
    const { sectionConfigurations } = useSectionConfigurations(type);
    const { sectionGroups } = useAvailableSections({
        sections: sectionConfigurations,
    });
    const { createLayoutSection } = useSection();
    const { dashboardFeatureFlags } = useDashboardFeatureFlags();
    const { installedPlatformApps } = useInstalledPlatformApps({
        enabled: dashboardFeatureFlags.developersHMAC.enabled,
    });
    const handleCreateLayoutSection = (sectionType, blockId, appId) => {
        const defaultPosition = type === 'header' ? 1 : undefined;
        createLayoutSection(sectionType, blockId, position || defaultPosition, appId);
    };
    const mergedSectionGroups = useMemo(() => {
        if (!sectionGroups)
            return [];
        const appGroups = installedPlatformApps
            ?.filter((app) => app.sections.length > 0 && blockId === 'content_for_index')
            .map((app) => {
            return {
                group: app.displayName,
                sections: app.sections.map((section) => ({
                    sectionType: section.id,
                    name: section.name || '',
                    maxBlocks: 1,
                    platformAppId: app.id,
                    additionalInfo: {
                        description: section.description || '',
                        groupName: app.displayName,
                        position: 1,
                    },
                    presets: [],
                })),
            };
        }) || [];
        return [...sectionGroups, ...appGroups];
    }, [sectionGroups, installedPlatformApps]);
    return (React.createElement(AddSectionModalView, { blockId: blockId, sections: mergedSectionGroups, onCreateLayoutSection: handleCreateLayoutSection, filterSections: dashboardFeatureFlags.developersHMAC.enabled ? [] : ['hmac'] }));
};
